import React from 'react';
// import label from '../../utils/lngEn';
// import config from '../../config';
import * as commonActions from '../../actions/commonActions';

const LimitPreferenceRow = ({ limitPreference, courses, onDelete, handleEdit }) => {
  let count_text = limitPreference.limit == 3 ? 'three' : (limitPreference.limit == 1 ? 'one': 'two');
  return (
    <div>
        <div className="conflict-row">
          <div className="conflict-name">
            <div className="name">
              <span
                onClick={() => {
                  handleEdit(limitPreference);
                }}
              >
                {`Assign me no more than ${count_text} of:`}
              </span>
            </div>
            {/* <div className="conflict-kind">
              Kind: <span>{limitPreference.kind == 1 ? 'Number' : 'Weight'}</span>
            </div>
            {' | '}
            <div className="conflict-limit">
              Limit: <span>{limitPreference.limit}</span>
            </div> */}
          </div>
          <div className="conflict-courses">
            {limitPreference.courses.map(course => {
              return (
                <div key={course} className="conflict-course">
                  {commonActions.getCourseName(course, courses)}
                </div>
              );
            })}
          </div>
          <div className="icon-delete">
            <i
              onClick={() => {
                onDelete(limitPreference.id, limitPreference.name);
              }}
              className="fa fa-trash-o"
              style={{ cursor: 'pointer' }}
            />
          </div>
        </div>
    </div>
  );
};

export default LimitPreferenceRow;



// WEBPACK FOOTER //
// ./src/components/rank/LimitPreferenceRow.js